// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text[data-v-f79c6bca] {\n  font-size: 22px;\n  color: #ff942c;\n  font-weight: bold;\n  margin-top: 14px;\n  text-align: center;\n  line-height: 40px;\n  background: #f5f5f5;\n}\np[data-v-f79c6bca]{\n  font-weight: bold;\n  text-indent: 32px;\n  font-family: 黑体;\n  line-height: 30px;\n}\n.textsty[data-v-f79c6bca]{\n  font-weight: normal;\n}\n\n", ""]);
// Exports
module.exports = exports;
